import type { AuthenticatedUser } from "../api/auth";
import { getGlobalLaunchpadTiles } from "./globalApplications.js";
import { TenantContainer } from "./TenantContainer";
import "./FallbackTenant.css";

interface FallbackTenantProps {
  currentUser?: AuthenticatedUser;
}

/**
 * Fallback Tenant Component
 * 
 * Wird angezeigt, wenn ein Tenant noch keine dedizierte UI-Konfiguration hat.
 * Zeigt eine leere Launchpad-Ansicht mit einer hilfreichen Nachricht.
 */
export function FallbackTenant({ currentUser }: FallbackTenantProps) {
  const fallbackContent = (
    <div className="fallback-tenant-message">
      <div className="fallback-tenant-icon" aria-hidden="true">
        <svg width="64" height="64" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
          <circle cx="12" cy="12" r="10"></circle>
          <line x1="12" y1="8" x2="12" y2="12"></line>
          <line x1="12" y1="16" x2="12.01" y2="16"></line>
        </svg>
      </div>
      <h1 className="fallback-tenant-title">Mandant wird eingerichtet</h1>
      <p className="fallback-tenant-description">
        Dein Mandant wurde erfolgreich angelegt. Die Konfiguration der Benutzeroberfläche wird in Kürze hinterlegt.
      </p>
      <p className="fallback-tenant-hint">
        Bitte wende dich an deinen Administrator, um die Einrichtung abzuschließen.
      </p>
      {currentUser?.tenantId && (
        <div className="fallback-tenant-details">
          <strong>Tenant-ID:</strong> <code>{currentUser.tenantId}</code>
        </div>
      )}
    </div>
  );

  return (
    <TenantContainer
      tiles={[]}
      routes={[{ path: "/", element: fallbackContent }]}
      currentUser={currentUser}
    />
  );
}
